import NewHome from './NewHome'
export default NewHome
